
define(
	'AnchorGroup.ESDBillingNotification.Checkout'
	, [
		'AG.CustomFunctions'
	]
	, function (
		AGCust
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				AGCust.checkAndNotifyESDBilling();
			}
		};
	});
